import { render } from "./ArticleIcons.vue?vue&type=template&id=54975c82&scoped=true"
import script from "./ArticleIcons.vue?vue&type=script&lang=js"
export * from "./ArticleIcons.vue?vue&type=script&lang=js"

import "./ArticleIcons.vue?vue&type=style&index=0&id=54975c82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54975c82"

export default script